import { ENV } from "../utils";

export class WorkEnvironment {
  baseApi = ENV.BASE_API;

  async getWorkEnvironments(accessToken, active = true) {
    const url = `${this.baseApi}/work-environments?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createWorkEnvironment(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-work-environment`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateWorkEnvironment(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-work-environment/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteWorkEnvironment(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-work-environment/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
